import { useEffect } from "react";

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title ? `${title} — Cargowyn Logistics Group` : "Cargowyn Logistics Group";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    if (description) meta.setAttribute("content", description);
    window.scrollTo(0, 0);
  }, [title, description]);
}
